import { createContext, useContext, type ReactNode } from 'react'
import type { ClientConfig } from '../types/clientConfig'

const ClientConfigContext = createContext<ClientConfig | null>(null)

export function useClientConfig(): ClientConfig {
  const config = useContext(ClientConfigContext)
  if (!config) {
    throw new Error('useClientConfig must be used within a ClientConfigProvider')
  }
  return config
}

interface ClientConfigProviderProps {
  config: ClientConfig
  children: ReactNode
}

export function ClientConfigProvider({ config, children }: ClientConfigProviderProps) {
  return (
    <ClientConfigContext.Provider value={config}>
      {children}
    </ClientConfigContext.Provider>
  )
}
